import React from 'react';
import { useForm } from 'react-hook-form';
import ButtonPrimary from '../../../common/Buttons/ButtonPrimary';
import ButtonSecondary from '../../../common/Buttons/ButtonSecondary';

import {
  Input,
  Label,
  InputColumn,
  ContactForm,
  CardContentWrapper,
  Select,
  WhiteSpace,
  FullFlexCont,
  Column,
} from '../../formStyledComponents';

const NewDigital = ({
  addDigital,
  levels,
  littleDevice,
  setSelectedDigital,
  isAddModal,
  setSelectedCvAdd,
  isEditModal,
}) => {
  const { register, handleSubmit } = useForm();

  const onSubmit = (data, e) => {
    e.preventDefault();
    addDigital(data);
  };


  return (
    <CardContentWrapper mobilePadding="0" padding={isAddModal || isEditModal && '0'}>
      <ContactForm onSubmit={handleSubmit(onSubmit)}>

        <FullFlexCont padding="0" between mobilePadding="0">
          <InputColumn
            width={isAddModal || isEditModal ? '100%' : 'max-content'}
            margin="0 3rem 0 0"
            alignCenter={littleDevice}
          >
            <Label>Competencia digital:</Label>
            <Input
              name="name"
              placeholder="competencia digital"
              ref={register({ required: true })}
              mobileWidth="80%"
              mobileMargin="0"
            />
          </InputColumn>
        </FullFlexCont>

        <WhiteSpace height="2rem" />

        <FullFlexCont padding="0" between mobilePadding="0">
          <InputColumn
            width="30%"
            alignCenter={littleDevice}
            width={isAddModal || isEditModal ? '100%' : '40%'}
          >
            <Label>Nivel:</Label>
            <Select
              width="100%"
              mBottom="0"
              name="level"
              ref={register({ required: true })}
              mobileWidth="80%"
              mobileMargin="0"
            >
              <option key="default">nivel</option>
              {levels.map((op) => <option key={op.value} value={op.value}>{op.label}</option>)}
            </Select>
          </InputColumn>

          <InputColumn
            width={isAddModal || isEditModal ? '100%' : '40%'}
            alignCenter={littleDevice}
          >
            <Label>Certificado:</Label>
            <Input
              name="certificate"
              placeholder="certificado"
              ref={register({ required: false })}
              mobileWidth="80%"
              mobileMargin="0"
            />
          </InputColumn>
        </FullFlexCont>

        {!littleDevice && (
          <>
            <WhiteSpace height="4rem" />
            <ButtonPrimary
              iconColor="#105285"
              type={2}
              text="Guardar datos"
              htmlType="submit"
              margin="0 0 0 auto"
            />
          </>
        )}

        {littleDevice && (
          <FullFlexCont justify="space-between">

            <WhiteSpace height="1rem" />

            <Column width="46" padding="0">
              <ButtonSecondary
                text="Atrás"
                onClick={!isAddModal ? () => setSelectedDigital(null) : () => setSelectedCvAdd(null)}
                margin="auto"
                fullWidth
              />
            </Column>

            <Column width="46" padding="0">
              <ButtonPrimary
                type={2}
                text="Guardar"
                htmlType="submit"
                margin="auto"
                fullWidth
              />
            </Column>

          </FullFlexCont>
        )}

        <WhiteSpace height="4rem" />

      </ContactForm>
    </CardContentWrapper>
  );
};

export default NewDigital;
